module.exports = __webpack_public_path__ + "img/IMG_2622.75804abe.JPG";